module.exports = __webpack_public_path__ + "img/Stationery@2x.png";